import React, {PureComponent} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {StatementItem} from "@irati/types"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import StatusType from "@irati/wallet/types/enums/Status"

import PrimaryDetails from "../../../PrimaryDetails"
import {StyledCard} from "../../styled"


interface Props extends InjectIntl, WithBranding {
  statementItem: StatementItem,
  idNamespace: string
}

class MontlyTTTopUp extends PureComponent<Props> {
  render() {
    const {statementItem, formatMessage, idNamespace, branding} = this.props

    const {transfer} = statementItem
    const {amount, currency} = transfer
    const primaryDetails = {
      image: branding.businessLogoUrl || perkboxLogo,
      title: formatMessage({id: "wallet.statementItem.topup.primaryDetails.flexiPoints.title"}),
      subTitle: formatMessage({id: "wallet.statementItem.topup.primaryDetails.subTitle"}),
      amount,
      currency,
      status: StatusType.CLEARED
    }

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails id={idNamespace} data={primaryDetails} imgHeightAuto />
      </StyledCard>
    )
  }
}

export default injectIntl(withBranding(MontlyTTTopUp))
